import { Component, OnInit, SimpleChanges, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { JobService } from '../../services/jobs/job.service';
import { MaterialService } from '../../services/material.service';
import { FormGroup, FormBuilder, FormControl, FormArray, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { MatSnackBar } from '@angular/material';
import { DocumentService } from '../../services/document.service';
import { PortfolioService } from '../../services/portfolio/portfolio.service';
import { saveAs } from "file-saver";
import * as moment from 'moment';
// import { until, EventEmitter } from 'protractor';
import { CourseUnitsService } from '../../services/course-units.service';
import { FileGenerationService } from '../../services/file-generation.service';
// import undefined = require('firebase/empty-import');
@Component({
  selector: 'app-iv-plan-form',
  templateUrl: './iv-plan-form.component.html',
  styleUrls: ['./iv-plan-form.component.scss'],
})
export class IvPlanFormComponent implements OnInit {

  @Input('job') selectedJob;
  @Input('units') unitList
  @Input('learnerList') learners
  @Input('sampleList') sampleList
  @Input('jobEdit') editJob
  @Output() sampleListUpdate: EventEmitter<any> = new EventEmitter<any>();
  qualificationForm;
  learnerForm;
  otherDetailsForm;
  jobId;
  // isSubmitValid;
  singleJobDetails;
  courseTitle;
  instructorsList = [];
  selectedAssessors = [];
  selectedVerifieres = [];
  selectedLead = []
  displayVerifier = []
  internalVerifier = []
  //unitList = []
  assignmentList = []
  isEdit = false
  planFormDetails
  planFormDetailsCopy
  courseType
  courseId
  //sampleList = [];
  sampleType;
  allLearners = []
  loading;
  user
  reload = false;
  assessorNames = []
  IQANames = []
  assesorList = []
  verifierList = []
  allPlanForms: any;
  selectedValue: any;
  constructor(
    public jobService: JobService,
    public formBuilder: FormBuilder,
    public materialService: MaterialService,
    public documentService: DocumentService,
    public _snackBar: MatSnackBar,
    public _portfolioService: PortfolioService,
    public cd: ChangeDetectorRef,
    public unitService: CourseUnitsService,
    public _fileGenerationService: FileGenerationService
  ) {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
  }

  ngOnInit() {
    // this.isSubmitValid = true;
    // this.selectedValue = 'Summitive'
    this.createForm()
    this.createLearnerForm()
    this.creteOtherDetailsForm()
    console.log('this.unitList onInit', this.unitList)

  }



  ngOnChanges(changes: SimpleChanges): void {
    console.log("changes in iv plan form", changes)
    if (changes.selectedJob && changes.selectedJob.currentValue) {
      this.jobId = changes.selectedJob.currentValue

      // console.log("single job id in plan form", this.jobId);
      this.getJobDetails()
      // this.getAssignmentOfJob()
      this.getIqaFormDetails()
      //this.getUnits()
    }

    if (changes.learners && changes.learners.currentValue) {
      this.allLearners = changes.learners.currentValue
      console.log("all learners data==========", this.allLearners);

    }
    if (changes.editJob && changes.editJob.currentValue) {
      this.getJobDetails()
      // let updateJob = changes.editJob.currentValue
      // console.log("already created third form data", this.otherDetailsForm);

      // let groupArray = <FormArray>this.otherDetailsForm.get('assessorDetails')
      // console.log("what is group", groupArray);
      // _.forEach(groupArray, (item) => {

      // })

    }

    //  if (changes.unitList) {
    //    console.log("units list ---------->", changes.units.currentValue)
    //}

  }


  // FORM GROUP


  createForm(flag?) {
    console.log("what is the details in first form for plan", this.selectedAssessors, this.assessorNames);

    this.qualificationForm = new FormGroup({
      qualificationTitle: new FormControl(this.courseTitle),
      assessors: new FormControl((this.assessorNames && this.assessorNames.length) ? this.assessorNames : this.selectedAssessors),
      sampleType: new FormControl(this.selectedValue ? this.selectedValue : 'Summitive', Validators.required),
      //acedemicYear: new FormControl((details && details.acedemicYear) ? details.acedemicYear : ''),
      verifieres: new FormControl((this.IQANames && this.IQANames.length) ? this.IQANames : this.selectedVerifieres),
      //leadName: new FormControl((details && details.leadName) ? details.leadName : ''),
      //meetingDates: new FormControl((details && details.meetingDates) ? details.meetingDates : '')
    })
    console.log("value of create form after every execution", this.qualificationForm.value, "flag value", flag, "this.assessorNames", this.assessorNames, "this.selectedAssessors", this.selectedAssessors);

    if (this.user && (this.user.isTrainer || this.user.isMp || this.user.isClient)) {
      this.qualificationForm.disable()
    }
    if (this.user && (this.user.isAdmin || this.user.isIQA)) {
      this.qualificationForm.enable()
    }
  }

  createLearnerForm(details?, assignment?) {
    console.warn("RE CREATING THE FORM", details)
    this.learnerForm = new FormGroup({
      learners: this.formBuilder.array(this.multipleLearners(details, assignment))
    })
    this.learnerForm.valueChanges.subscribe((value) => {
      console.log('form value changed', value)
      this.cd.detectChanges()
    });
    if (this.user && (this.user.isTrainer || this.user.isMp || this.user.isClient)) {
      this.learnerForm.disable()
    }
    if (this.user && (this.user.isAdmin || this.user.isIQA)) {
      this.learnerForm.enable()
    }
    //this.cd.detectChanges()
    // console.log("value of form", this.learnerForm);
  }








  get learnerDetails() { return <FormArray>this.learnerForm.get('learners'); }
  multipleLearners(learners?, units?) {
    // console.log("all learners array", learners);

    if (learners && learners.length) {
      let unitArray = []
      _.forEach(learners, async (unit) => {
        await unitArray.push(new FormGroup({
          _id: new FormControl((unit && unit.assessorId) ? unit.assessorId : unit._id),
          name: new FormControl((unit && unit.name) ? unit.name : unit.name),
          verifierName: new FormControl((unit && unit.verifierName) ? unit.verifierName : this.selectedVerifieres),
          unitList: this.formBuilder.array(this.multipleUnits((unit && unit.unitList) ? unit.unitList : units))
        }))


      })
      console.log('unitssssssssssssss', unitArray)
      return unitArray;
    } else {
      return [this.formBuilder.group({
        _id: new FormControl(''),
        name: new FormControl(''),
        verifierName: new FormControl(''),
        unitList: this.formBuilder.array(this.multipleUnits(units))
      })]
    }
  }


  multipleUnits(unit) {
    console.log("what is units", unit);

    if (unit && unit.length) {
      let unitArray = []
      _.forEach(unit, async (unit) => {
        await unitArray.push(new FormGroup({
          unitTitle: new FormControl((unit && unit.unitTitle) ? unit.unitTitle : unit.title),
          unitId: new FormControl((unit && unit.unitId) ? unit.unitId : unit._id),
          unitStatus: new FormControl((unit && unit.unitStatus) ? unit.unitStatus : unit.unitStatus),
          //assignmentList: this.formBuilder.array(this.multipleAssignment((unit && unit.assignmentList) ? unit.assignmentList : unit.assignment))
        }))
      })
      return unitArray;
    }
    else {
      return [this.formBuilder.group({
        unitTitle: new FormControl(''),
        unitId: new FormControl(''),
        unitStatus: new FormControl(''),
        //assignmentList: this.formBuilder.array(this.multipleAssignment(array))
      })]
    }
  }

  //learner -> 0 -> unitList -> 0 assignmentList ->0 -> assignmentStatus

  multipleAssignment(assignment?) {
    // console.log("single unit total asssignment list", assignment);

    if (assignment && assignment.length) {
      let unitArray = []
      _.forEach(assignment, async (unit) => {
        await unitArray.push(new FormGroup({
          assignmentNo: new FormControl(unit.assignmentNo),
          assignmentStatus: new FormControl((unit && unit.assignmentStatus) ? unit.assignmentStatus : '')
        }))
      })
      return unitArray;
    }
    else {
      return [this.formBuilder.group({
        assignmentNo: new FormControl(''),
        assignmentStatus: new FormControl('')
      })]
    }
  }


  creteOtherDetailsForm(details?) {
    console.log("details in creteOtherDetailsForm", details)
    this.otherDetailsForm = new FormGroup({
      assessorDetails: this.formBuilder.array(this.multipleAssessors(details))
    })
    if (this.user && (this.user.isTrainer || this.user.isMp || this.user.isClient)) {
      this.otherDetailsForm.disable()
    }
    if (this.user && (this.user.isAdmin || this.user.isIQA)) {
      this.otherDetailsForm.enable()
    }
  }


  get otherDetails() { return <FormArray>this.otherDetailsForm.get('assessorDetails'); }
  multipleAssessors(assesment?) {

    if (assesment && assesment.length) {

      let unitArray = []
      _.forEach(assesment, async (unit) => {
        if (unit && unit.assessmentDecisions) {
          // this.isSubmitValid = false;
        }

        await unitArray.push(new FormGroup({
          assessorName: new FormControl((unit && unit.assessorName) ? unit.assessorName : unit.name),
          assessmentDecisions: new FormControl((unit && unit.assessmentDecisions) ? unit.assessmentDecisions : ''),
          rationaleDecisions: new FormControl((unit && unit.rationaleDecisions) ? unit.rationaleDecisions : '')
        }))
      })
      return unitArray;
    } else {
      return [this.formBuilder.group({
        assessorName: new FormControl(''),
        assessmentDecisions: new FormControl(''),
        rationaleDecisions: new FormControl('')
      })]
    }
  }


  // UTILITY

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }

  selectAssessor(event) {
    console.log("event when remove assessors", event);

    // this.createLearnerForm(this.selectedAssessors)

  }

  displayAssessor(event?) {
    // console.log("when call this button", event);
    // if (this.isEdit == false) {

    if (event == false) {
      if (this.selectedVerifieres && this.selectedVerifieres.length) {
        this.displayVerifier = this.selectedVerifieres
      } else {
        this.displayVerifier = this.verifierList
      }
    }
    if (event == undefined) {
      if (this.selectedVerifieres && this.selectedVerifieres.length) {
        this.displayVerifier = this.selectedVerifieres
      } else {
        this.displayVerifier = this.verifierList
      }
    }
  }

  compareObjects(o1: any, o2: any): boolean {
    // console.log("compareObjects called", o1._id, o2._id)
    if (o1 && o2) {
      return o1._id === o2._id;
    }

  }


  closeSelect(event) {
    if (event == false) {
      console.log("event when select is closed", event);
      if (this.isEdit == false) {
        //this.createLearnerForm(this.sampleList, this.unitList)
        console.log("what is the verifier list", this.displayVerifier);

        this.selectedAssessors.forEach((item) => {
          let index = this.singleJobDetails.sampleSize.find(x => x._id === item._id);
          console.log("selecte inst data", index);
          item['assessmentDecisions'] = index.sampleSize

          // if
        })

        // this.creteOtherDetailsForm(this.selectedAssessors)
      } else {
        //console.log("selected learner data", this.selectedAssessors);
        //console.log("already exits array ", this.planFormDetails.details.learnerForm.learners);
        let newArray = []
        let display = this.planFormDetails.details.learnerForm.learners

        let thirdForm = this.planFormDetails.details.otherDetailsForm.assessorDetails


        if (newArray && newArray.length) {
          console.log("what is the final array to send", newArray);
          newArray.forEach((item) => {
            let obj = {
              _id: item._id,
              name: item.name,
              unitList: this.unitList
            }
            display.push(obj)
            let obj1 = {
              name: item.name
            }
            thirdForm.push(obj1)
          })

          //this.createLearnerForm(display)
          // this.creteOtherDetailsForm(thirdForm)
        } else {
          let updateArray = []
          let thirdArray = []
          let value = this.selectedAssessors.forEach((item) => {
            // console.log("single item of selected arrat", item);

            let data = display.find(x => x._id == item._id)
            // console.log("element is find or not", data);
            if (data != undefined) {
              updateArray.push(data)
            }
          })

          let value1 = this.selectedAssessors.forEach((item) => {
            // console.log("single item of selected arrat", item);

            let data = thirdForm.find(x => x.assessorName == item.name)
            console.log("element is find or not", data);
            if (data != undefined) {
              thirdArray.push(data)
            }
          })
          console.log("third form array value", thirdArray);

          console.log("what is new array in else part", updateArray);


          //this.createLearnerForm(updateArray)
          // this.creteOtherDetailsForm(thirdArray)
        }
      }
    }
  }
  stepperClick(event) {
    console.log("event stepper title is clicked", event);

  }

  getAssignment(i, j) {
    return this.learnerForm.controls.learners.controls[i].controls.unitList.controls[j].controls.assignmentList.controls

    // return assignment.assignmentStatus.value
  }

  sampleTypeFilter(event) {
    this.selectedValue = event.value
    console.log("event", event)
    console.log("this.allPlanForms", this.allPlanForms)
    let index;
    let edit;
    if (this.allPlanForms && this.allPlanForms.length) {
      //this.allPlanForms.forEach((item, index )=> {
      //    if (item.details && item.details.qualificationForm && item.details.qualificationForm.sampleType) {
      //        if (item.details.qualificationForm.sampleType == event.value) {
      //            this.isEdit = true
      //            //Display the selected SampleType data
      //            this.displayData(index)
      //        } else {
      //            this.isEdit = false
      //        }
      //    }
      //})
      index = _.findIndex(this.allPlanForms, function (o) {
        console.log("o", o)
        if (o.details && o.details.qualificationForm && o.details.qualificationForm.sampleType) {
          if (o.details.qualificationForm.sampleType == event.value) {
            console.log("in if")
            edit = true
            //Display the selected SampleType data
            return o
          } else {
            console.log("in else")
            //this.isEdit = false
          }
        }
      });

      this.isEdit = edit == true ? edit : false
      this.displayData(index)
    }
    console.log("this.isEdit", this.isEdit, "index", index)
  }

  displayData(value) {
    let index = this.isEdit == true ? value : -1
    console.log("index in display data", index)
    if (index > -1) {
      this.planFormDetails = this.allPlanForms[index]
      this.planFormDetailsCopy = this.allPlanForms[index]
      this.courseTitle = this.planFormDetails.details.qualificationForm.qualificationTitle
      this.selectedVerifieres = this.planFormDetails.details.qualificationForm.verifieres
      this.IQANames = this.planFormDetails.details.qualificationForm.verifieres
      this.selectedValue = this.planFormDetails.details.qualificationForm.sampleType
      if (this.selectedVerifieres && this.selectedVerifieres.length) {
        this.displayVerifier = this.selectedVerifieres
      } else {
        this.displayVerifier = this.verifierList
      }
      // this.selectedAssessors = this.planFormDetails.details.qualificationForm.assessors
      this.assessorNames = this.planFormDetails.details.qualificationForm.assessors
      this.createForm()
      this.createLearnerForm(this.planFormDetails.details.learnerForm.learners)
      this.creteOtherDetailsForm(this.planFormDetails.details.otherDetailsForm.assessorDetails)
    } else {
      this.planFormDetails = ''
      this.assessorNames = []
      //console.log("in else and creating a blank form", this.selectedAssessors, "this.assessorList", this.assesorList, "this.assessorNames", this.assessorNames, "this.displayAsessors", this.displayAssessor)

      this.createLearnerForm(this.allLearners, this.unitList)
      //this.creteOtherDetailsForm(this.selectedAssessors)
      if (this.singleJobDetails && this.singleJobDetails.sampleSize && this.singleJobDetails.sampleSize.length) {
        // this.isSubmitValid = false;
        this.selectedAssessors = this.assesorList
        console.log("sample size present", this.selectedAssessors)
        if (this.selectedAssessors && this.selectedAssessors.length > 0) {
          this.selectedAssessors.forEach((item) => {
            if (item) {
              console.log("what is item", this.singleJobDetails);
              let index = this.singleJobDetails.sampleSize.find(x => x._id === item._id);
              console.log("selecte inst data", index);
              if (index != undefined) {
                item['assessmentDecisions'] = index.sampleSize
              }
            }
          })
          console.log("this.selectedAssessors.length", this.selectedAssessors)
          this.creteOtherDetailsForm(this.selectedAssessors)

        } else {
          console.log("this.assessorList.length", this.assesorList)
          this.creteOtherDetailsForm(this.assesorList)
        }
        this.createForm()
      } else {
        console.log("sample size absent")
        this.createForm()
        this.creteOtherDetailsForm(this.assesorList)
      }
    }

  }
  downloadMedical() {

    this.loading = true
    // if (this.planFormDetails && this.planFormDetails._id) {
    //     let obj = {
    //         docId: this.planFormDetails._id,
    //         type: 'IQAplan',
    //     }
    //     this.documentService.download(obj).subscribe((res) => {
    //         console.log("res.data", res.data.data.data)
    //         let byteArray = new Uint8Array(res.data.data.data);
    //         console.log("======byteArray =======", byteArray)
    //         let blob = new Blob([byteArray], { type: 'application/pdf' });
    //         console.log("blobblobblobblobblob", blob)
    //         let location = []
    //         this.singleJobDetails.clients.forEach((item) => {
    //             location.push(item.location.title)
    //         })
    //         let title = 'Assessment Plan_' + location.join('-') + '_' + moment(new Date).format("DD-MM-YYYY")
    //         saveAs(blob, title);
    //         this.loading = false
    //     })
    // } else {
    //     this.openSnackBar("No document with selected sample type","OK")
    // }

    // let location = []
    // console.log("value to download form", this.planFormDetails)
    // let obj = {
    //   planFormDetails: this.planFormDetails,
    //   unitList: this.unitList,
    //   singleJobDetails: this.singleJobDetails
    // }
    // this._fileGenerationService.downloadIQAPlan(obj).subscribe(csv => {
    //   console.log("csv response", csv)
    //   const byteCharacters = atob(csv);
    //   console.log('byteCharacters', byteCharacters)
    //   const byteNumbers = new Array(byteCharacters.length);
    //   for (let i = 0; i < byteCharacters.length; i++) {
    //     byteNumbers[i] = byteCharacters.charCodeAt(i);
    //   }
    //   const byteArray = new Uint8Array(byteNumbers);
    //   let blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //   this.singleJobDetails.clients.forEach((item) => {
    //     location.push(item.location.title)
    //   })
    //   let title = 'Assessment Plan_' + location.join('-') + '_' + moment(new Date).format("DD-MM-YYYY")
    //   saveAs(blob, title + ".xlsx");
    //   this.loading = false
    // })

    let obj = {
      metaObj: {
        title: 'IQAplan',
      },
      jobId: this.jobId,
      onModel: 'job',
      documentMetaId: this.planFormDetails.documentMetaId._id,
      documentId: this.planFormDetails._id,
      details: {}
    }

    let details = {
      qualificationForm: this.qualificationForm.value,
      learnerForm: this.learnerForm.value,
      otherDetailsForm: this.otherDetailsForm.value
    }
    obj['details'] = details
    console.log("obj to be send to server------->", obj);
    this.documentService.download(obj).subscribe((res) => {

      if (res.data.msg && res.data.msg == 'Pdf Not Generated') {
        console.log("res in plan pdf", res)
        this.loading = false
        this.openSnackBar("Pdf couldnt be generated as there are no samples!", "OK")
      } else {
        console.log("res.data", res.data)
        let byteArray = new Uint8Array(res.data.data.data);
        console.log("======byteArray =======", byteArray)
        let blob = new Blob([byteArray], { type: 'application/pdf' });
        console.log("blobblobblobblobblob", blob)
        let location = []
        this.singleJobDetails.clients.forEach((item) => {
          location.push(item.location.title)
        })
        let title = 'Assessment Plan_' + location.join('-') + '_' + moment(new Date).format("DD-MM-YYYY")
        saveAs(blob, title);
        this.loading = false
      }

    })


  }



  sampleLearner(el) {
    // console.log('this.sampleListthis.sampleListthis.sampleListthis.sampleList', this.sampleList)
    if (this.sampleList) {
      let index = this.sampleList.findIndex(x => x._id === el._id);
      if (index > -1) {
        let style = {
          'background-color': 'var(--theme-color-light-blue)'
        }
        return style
      } else {
        let style = {
          'background-color': 'var(--theme-color-white)'
        }
        return style
      }
    }
  }


  // API CALL

  /**
   * Get single job details
   */
  getJobDetails() {
    this.loading = true

    this.jobService.getJobById(this.jobId).subscribe((response) => {
      console.log("response of single job details", response.data[0]);
      this.singleJobDetails = response.data[0]
      this.courseType = this.singleJobDetails.course.type
      this.courseId = this.singleJobDetails.course._id
      if (this.courseType != 'Level2') {
        //this.getAssignmentOfJob()
        this.getUnits()
      } else {
        this.getLevel2Units()
      }
      this.courseTitle = this.singleJobDetails.course.title
      this.instructorsList = this.singleJobDetails.instructors
      this.sampleList = this.singleJobDetails.samples

      //this.createLearnerForm(this.sampleList, this.unitList)
      if (this.isEdit == false) {
        console.log("call this or not", this.singleJobDetails);
        this.selectedAssessors = []
        this.singleJobDetails.instructors.forEach((inst) => {
          if (inst.role == 'trainer') {
            this.selectedAssessors.push(inst)
            this.assesorList.push(inst)
          }
          if (inst.role == 'IQA') {
            this.verifierList.push(inst)
          }
          // if (inst.userId && inst.userId.userRole.includes('trainer') && !inst.userId.userRole.includes('IQA')) {
          //   this.selectedAssessors.push(inst)
          //   this.assesorList.push(inst)
          // }
          // if (inst.userId && inst.userId.userRole.includes('IQA')) {
          //   // this.selectedVerifieres.push(inst)
          //   this.verifierList.push(inst)
          // }
        })
        this.displayVerifier = this.verifierList
        console.log("value of selected verifier", this.verifierList);

        this.qualificationForm.controls.qualificationTitle.setValue(this.courseTitle)
        this.qualificationForm.controls.assessors.setValue(this.selectedAssessors)
        this.qualificationForm.controls.verifieres.setValue(this.selectedVerifieres)

        if (this.singleJobDetails && this.singleJobDetails.sampleSize && this.singleJobDetails.sampleSize.length) {
          this.selectedAssessors.forEach((item) => {
            let index = this.singleJobDetails.sampleSize.find(x => x._id === item._id);
            console.log("selecte inst data", index);
            item['assessmentDecisions'] = index.sampleSize
          })
          this.creteOtherDetailsForm(this.selectedAssessors)
        } else {
          this.creteOtherDetailsForm(this.selectedAssessors)
        }


        // this.createForm()
        // this.createLearnerForm(this.sampleList, this.unitList)
        // this.displayVerifier = this.instructorsList
      } else {

        this.assesorList = []
        this.singleJobDetails.instructors.forEach((inst) => {
          if (inst.role == 'trainer') {
            this.assesorList.push(inst)
          }
          if (inst.role == 'IQA') {
            this.verifierList.push(inst)
          }
          // if (inst.userId && (inst.userId.userRole.includes('trainer') && !inst.userId.userRole.includes('IQA'))) {
          //   // this.selectedAssessors.push(inst)
          //   this.assesorList.push(inst)
          // }
          // if (inst.userId && inst.userId.userRole.includes('IQA')) {
          //   // this.selectedVerifieres.push(inst)
          //   this.verifierList.push(inst)
          // }
        })
        let tempArray = this.planFormDetails.details.otherDetailsForm.assessorDetails
        let newAssignArray = []
        if (this.singleJobDetails && this.singleJobDetails.sampleSize && this.singleJobDetails.sampleSize.length && this.assesorList && this.assesorList.length) {
          this.assesorList.forEach((item) => {
            console.warn("this.assesorList", this.assesorList)
            let index = this.singleJobDetails.sampleSize.find(x => x._id === item._id);
            console.warn("selecte inst data", index);
            let tempIndex
            if (index != undefined) {
              tempIndex = tempArray.filter((o) => o.assessorName == index.name)

              console.warn("temp index value ", tempIndex);
              if (tempIndex && !tempIndex.length) {
                let obj = {
                  assessorName: index && index != undefined ? index.name : '',
                  assessmentDecisions: index && index != undefined ? index.sampleSize : '',
                  rationaleDecisions: ''
                }
                newAssignArray.push(obj)
              } else {
                console.warn("in else")
                let obj = {
                  assessorName: index && index != undefined ? index.name : '',
                  assessmentDecisions: index && index != undefined ? index.sampleSize : '',
                  rationaleDecisions: tempIndex[0].rationaleDecisions
                }
                console.warn("in else", obj)
                newAssignArray.push(obj)
              }
            }

            // item['assessmentDecisions'] = index.sampleSize
            // this.planFormDetails.details.otherDetailsForm.assessorDetails
            // if
          })
          console.warn("newAssignArraynewAssignArray", newAssignArray);

          this.creteOtherDetailsForm(newAssignArray)
        } else {
          // this.creteOtherDetailsForm(this.selectedAssessors)
        }


      }
      this.loading = false
    }, error => {
      console.log("error while get single job details", error);
      this.loading = false

    })
  }



  /**
   * Level3 jobs units with assignments
   */
  getAssignmentOfJob() {
    //this.loading = true
    //this.materialService.getMaterialUsingJobId(this.jobId).subscribe((response) => {
    //  console.log("response of all units with their assignment list", response);
    //  if (response && response.length) {
    //    //this.createLearnerForm(this.sampleList, this.unitList)
    //    this.unitList = response
    //    if (this.isEdit == false) {
    //      this.createLearnerForm(this.allLearners, this.unitList)
    //    }
    //    this.loading = false
    //  }

    //}, error => {
    //  this.loading = false
    //  console.log("error while get all assignment list", error);

    //})
  }
  getUnits() {
    this.loading = true
    console.log("what is the course id", this.courseId);
    // console.log("what is the value of dedfault vaar=======", this.defaultUnit);

    this.unitService.getUnits(this.courseId).subscribe(res => {
      this.unitList = res;
      console.log("units list by course id", this.unitList)
      // this.createLearnerForm(this.allLearners, this.unitList)
      if (this.isEdit == false) {
        this.createLearnerForm(this.allLearners, this.unitList)
      }
      this.loading = false
    })

  }



  /**
   * Level2 jobs units list with sessions
   */
  getLevel2Units() {
    this.unitList = []
    // this._portfolioService.getClassromGroupedByCourseId(this.courseId).subscribe(res => {
    //   this.loading = false
    //   console.log('classroom grouped portfolio', res);
    //   if (res && res.length) {
    //     let assignment = res
    //     assignment.forEach((item) => {
    //       console.log("single item", item);
    //       // let obj = {
    //       //   _id: item._id,
    //       //   title: item._id,
    //       //   assignment: []
    //       // }
    //       item.session.forEach((singleAssign) => {
    //         let obj = {
    //           _id: singleAssign.sessionId,
    //           unitTitle: "Unit-" + singleAssign.sessionUnit
    //         }
    //         // let obj1 = {
    //         //   assignmentNo: singleAssign.sessionUnit
    //         // }
    //         // obj.assignment.push(obj1)
    //         this.unitList.push(obj)
    //       })
    //     })
    //     if (this.isEdit == false) {
    //       this.createLearnerForm(this.allLearners, this.unitList)
    //     }

    //   }
    //   console.log("this is the final list to display ", this.unitList);
    // })





    // this.unitService.getUnits(this.courseId).subscribe(res => {
    //   console.log("response of all status", res);
    //   let unitArray = []
    //   let newArray = res.filter((o) => {
    //     if (o.title == 'Track Maintenance' || o.title == 'Technical Certificate') {
    //       unitArray.push(o)
    //     }
    //   })
    //   console.log("display unit array", unitArray);
    //   // let finalArray = []

    //   unitArray.forEach((item) => {
    //     // let obj = {
    //     //   _id: item.title,
    //     //   session: []
    //     // }
    //     let obj = {
    //       _id: item._id,
    //       title: item.title + ": Unit-" + item.unitNo
    //     }
    //     // let index = finalArray.findIndex(x => x._id === item.title);
    //     let index = this.unitList.findIndex(function (o) { return o._id == item._id })
    //     console.log("index of this element", index);
    //     if (index == -1) {
    //       this.unitList.push(obj)
    //     }
    //   })
    //   if (this.isEdit == false) {
    //     this.createLearnerForm(this.allLearners, this.unitList)
    //   }
    // })
    this.unitService.getUnits(this.courseId).subscribe(res => {
      let unitArray = []
      unitArray = res
      console.log("display unit array", unitArray);
      unitArray.forEach((item) => {
        if (item.unitNo != null) {
          if (this.singleJobDetails.course.title === 'Master Rails-Layout 2' || this.singleJobDetails.course.title === 'Level 2 NVQ & Tech Cert - EAL') item.title = "Unit-" + item.unitNo + " " + item.title
          this.unitList.push(item)
        }
      })
      if (this.isEdit == false) this.createLearnerForm(this.allLearners, this.unitList)
    })

  }


  /**
   * Add or Edit iqa plan form
   */
  submitIqaPlanForm() {
    this.loading = true
    console.log("first form value", this.qualificationForm.value);
    console.log("second form value", this.learnerForm.value);
    console.log("this is the final form value", this.otherDetailsForm.value);

    if (this.isEdit == true) {


      let obj = {
        metaObj: {
          title: 'IQAPlan',
        },
        jobId: this.jobId,
        onModel: 'job',
        documentMetaId: this.planFormDetails.documentMetaId._id,
        documentId: this.planFormDetails._id,
        details: {}
      }

      let details = {
        qualificationForm: this.qualificationForm.value,
        learnerForm: this.learnerForm.value,
        otherDetailsForm: this.otherDetailsForm.value
      }
      obj['details'] = details
      this.documentService.updateForm(obj).subscribe((response) => {
        console.log("response of iqa form", response);
        this.handleSnackBar({ msg: "Document saved successfully", button: "Ok" });
        this.loading = false
        // this.router.navigate(['/jobs/' + this.jobId], { queryParams: { courseType: this.courseType, currentTab: 6 } })
      }, error => {
        console.log("error while update form", error);
        this.loading = false
        this.handleSnackBar({ msg: "Something went wrong!", button: "Ok" });
      })

    } else {
      let obj = {
        metaObj: {
          title: 'IQAPlan',
        },
        jobId: this.jobId,
        onModel: 'job',
        details: {}
      }

      let details = {
        qualificationForm: this.qualificationForm.value,
        learnerForm: this.learnerForm.value,
        otherDetailsForm: this.otherDetailsForm.value
      }
      obj['details'] = details
      this.documentService.addDocument(obj).subscribe((response) => {
        console.log("document resposne of iqa form", response);
        this.isEdit = true;
        this.allPlanForms = []
        this.allPlanForms.push(response.data)
        this.displayData(0)
        this.handleSnackBar({ msg: "Document saved successfully!", button: "Ok" });
        this.loading = false
        // this.router.navigate(['/jobs/' + this.jobId], { queryParams: { courseType: this.courseType, currentTab: 6 } })
      }, error => {
        console.log("error while add iqa form", error);
        this.loading = false
        this.handleSnackBar({ msg: "Something went wrong!", button: "Ok" });
      })
    };
  }


  /**
   * Get iqa plan form details
   */
  getIqaFormDetails() {
    this.loading = true
    this.documentService.getIqaPlanFormValue(this.jobId).subscribe((response) => {
      console.log("response of plan form", response);
      if (response && response.length) {
        this.isEdit = true
        this.allPlanForms = response
        let index = 0
        this.displayData(index)
        this.loading = false
      }
    }, error => {
      console.log("error while get plan form value", error);
      this.loading = false
    })
  }

  /**
  * Generate a list of random learners based on sampleSize
  */

  generateSamples() {
    this.loading = true
    let obj = {
      jobId: this.jobId
    }
    console.log("job id", this.jobId)
    this.jobService.generateSamples(obj).subscribe((res: any) => {
      // console.log("samples generated of single job", res)
      this.loading = false
      if (res && !res.data) {
        console.log("first if call");
        this.handleSnackBar({ msg: res.msg, button: "Ok" });
      } else {


        console.log("call this or not", res);
        this.singleJobDetails = res.data.data[0]
        //this.reload = true;
        console.log('singleJobDetails after samples generated', this.singleJobDetails)
        this.sampleList = []
        this.sampleList = this.singleJobDetails.samples


        //this.learnerForm.reset()
        //this.ngOnChanges()
        console.log('this.sa,pleList', this.sampleList)
        console.log('this.allLearners', this.allLearners)
        this.sampleListUpdate.emit(this.sampleList)
        let tempLearners = this.allLearners;
        if (this.isEdit == false) {
          this.createLearnerForm(tempLearners, this.unitList)
          this.loading = false
        } else {
          this.createLearnerForm(tempLearners, this.unitList)
          this.loading = false
        }
        this.handleSnackBar({ msg: 'Samples Generated Successfully', button: 'OK' })
        this.cd.detectChanges();
      }

    })
  }
  // }

}
